import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "user",
    loadChildren: () => import("../../components/User/user.module").then((m) => m.UserModule)
  },
  {
    path: "my-wallet",
    loadChildren: () => import("../../components/wallet/wallet.module").then((m) => m.WalletModule)
  },
  {
    path: "ai-teacher",
    loadChildren: () => import("../../components/ai-teacher/ai-teacher.module").then((m) => m.AiTeacherModule),
  },
  {
    path:"chat",
    loadChildren: () => import("../../components/chat/chat.module").then((m) => m.ChatModule),
  }
];
